module.exports = __webpack_public_path__ + "img/38_18.26e85e43.png";